<template>
    <div class="w-view-shell">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>当前位置：首页</el-breadcrumb-item>
            <el-breadcrumb-item class="ke">购买课程</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="coupon-popup-shell" v-if="dialogVisible" @click.stop="dialogVisible=false">
            <div class="coupon-popup-content" @click.stop="">
                <div class="coupon-list">
                    <div class="coupon-box" v-for="(item,index) in coupon_list" :key="index"
                         @click.stop="select_couop(item,index)">
                        <div class="info-header">
                            <div class="info-tips">
                                {{item.coupon_type==1?'￥'+item.discount_money:(10-item.discount) + '折' }}
                            </div>
                            <div class="info-price">{{item.coupon_title}}</div>
                        </div>
                        <div class="info-bottom">
                            <div class="info-desc">有效期限</div>
                            <div class="info-time">{{item.start_time}}-{{item.end_time}}</div>
                        </div>
                        <div class="select-box">
                            <img src="@/assets/icon_check.png" alt="" v-if="item.accept_id==accept_id">
                        </div>
                    </div>
                </div>
                <div class="coupon-handle">
                    <div class="handle-btn" @click="dialogVisible = false,accept_id=0">不使用优惠</div>
                    <div class="handle-btn handle-btn2" @click="use_coupon">确认使用</div>
                </div>
            </div>
        </div>
        <!-- 支付的弹出框 -->
        <div class="coupon-popup-shell" v-if="pay_popup" @click.stop="clear_pay_timer">
            <div class="pay-content" @click.stop="">
                <div class="pay-content-header">
                    <div class="title">扫一扫付款 (元)</div>
                    <div class="pay-price">￥{{pay_money}}</div>
                </div>
                <div class="qrcode-list">
                    <div class="qrcode-box">
                        <div id="qrcode" ref="qrcode" style="width: 160px;height: 160px;" class="ewm"></div>
                        <div class="text">
                            <img class="img" src="@/assets/weixin.png" alt=""/>
                            <span>微信支付</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="purchase-shell">
            <div class="purchase-header">
                <div class="purchase-header-box" style="flex: 3">
                    课程信息
                </div>
                <div class="purchase-header-box" style="flex: 2">
                    课程价格
                </div>
                <div class="purchase-header-box" style="flex: 1">
                    操作
                </div>
            </div>
            <div class="goods-shell">
                <div class="goods-info" style="flex: 3">
                    <div class="goods-img">
                        <img :src="detail_info.course_img" alt="">
                    </div>
                    <div class="goods-info-shell">
                        <div class="goods-name">{{detail_info.course_name.length>40?detail_info.course_name.substring(0,36)+'...':detail_info.course_name}}</div>
                        <div class="goods-type">类别：{{detail_info.cate_name}}</div>
                        <div class="goods-type">学时：{{detail_info.cnt_course}}课时</div>
                    </div>
                </div>
                <div class="goods-info" style="flex: 2">
                    <div class="goods-price">
                        ￥{{detail_info.course_price}}
                    </div>
                </div>
                <div class="goods-info" style="flex: 1">
                    <router-link class="handle-btn" :to="'/Coursetobuy?course_id=' + course_id" replace>
                        查看课程
                    </router-link>
                </div>
            </div>
            <div class="coupon-shell">
                <div class="coupon-title">可用优惠券（{{coupon_list.length}}）</div>
                <div class="coupon-info">
                    <div class="select-coupon-btn" @click="dialogVisible = true"
                         v-show="!accept_id && coupon_list.length>0">选择优惠券
                    </div>
                    <div class="coupon-shell-show" v-show="accept_id>0" @click="dialogVisible = true">
                        {{coupon_info.coupon_title}}
                    </div>
                </div>
            </div>
            <div class="order-shell">
                <div class="order-info">课程金额：￥{{detail_info.course_price}}</div>
                <div class="order-info" v-if="accept_id>0 ">优惠券抵扣：-￥
                    {{coupon_info.coupon_type==1? (Number(detail_info.course_price)>=(coupon_info.target_money)?coupon_info.discount_money:'0.00'): ((detail_info.course_price-Number(detail_info.course_price)*(Number(coupon_info.discount))/10)).toFixed(2)}}
                </div>
                <div class="order-info" v-else>优惠券抵扣：-￥0.00</div>

                <div class="order-info order-price" v-if="accept_id>0">应付金额：￥
                    {{coupon_info.coupon_type==1?
                    (Number(detail_info.course_price)>=(coupon_info.target_money)?detail_info.course_price-coupon_info.discount_money:detail_info.course_price):(Number(detail_info.course_price)*Number(coupon_info.discount)/10).toFixed(2)}}
                </div>
                <div class="order-info order-price" v-else>应付金额：￥{{detail_info.course_price}}</div>
            </div>
            <div class="handle-list">
                <div class="pay-btn" @click="buy_course2(1)">
                    余额支付
                </div>
                <div class="pay-btn" @click="buy_course(2)">
                    微信支付
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import QRCode from 'qrcodejs2'

  export default {
    name: 'Purchase',
    data () {
      return {
        // 优惠卷弹出隐藏
        dialogVisible: false,
        // 是否选择优惠卷复选框
        checked: false,
        // 支付的弹出隐藏
        pay_popup: false,
        tableData: [
          {
            course_img: '',
            course_name: '',
            cnt_course: 0,
            name: '￥299',
            tag: '查看课程',
          },
        ],
        course_id: 1,
        detail_info: {
          course_img: '',
          course_name: '',
          cnt_course: 0,
          coupon_list: []
        },
        accept_id: 0, // 用户优惠券ID
        pay_way: 2, // 支付方式 1.余额 2.微信 3支付宝
        coupon_info: {
          coupon_type: 1,
          discount: 0
        },
        pay_timer: null,
        pay_money: '0.00',
        coupon_list: []
      }
    },
    mounted () {
      if (this.$route.query.course_id) {
        this.course_id = this.$route.query.course_id
        this.get_detail()
        this.get_coupon_list()
      }
    },
    beforeDestroy () {
      window.clearInterval(this.pay_timer)
    },
    methods: {
      clear_pay_timer () {
        this.pay_popup = false
        window.clearInterval(this.pay_timer)
      },
      get_order_detail (order_id) {
        this.API.post('user/user_infos-order_detail', {
          order_id: order_id,
        }).then((res) => {
          if (res.data.order_info.order_status != '待付款') {
            this.$message({
              showClose: true,
              message: '购买成功',
              type: 'success',
            })
            this.$router.push({ path: '/succeed?order_id=' + order_id })
          }
        })
      },
      make (linkUrl) {
        this.$refs.qrcode.innerHTML = '' // 防止重复生成
        let qrcode = new QRCode('qrcode', {
          width: 160,
          height: 160,
          text: linkUrl,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
        console.log(qrcode)
      },
      select_couop (item, index) {
        console.log(item)
        this.accept_id = item.accept_id
        this.coupon_info = item
      },
      // 购买课程
      buy_course (pay_way) {
        this.API.post('user/course_in-buy_course', {
          course_id: this.course_id,
          accept_id: this.accept_id, // 用户优惠券ID
          is_h5: 2,
          pay_way: pay_way, // 	支付方式 1.余额 2.微信 3支付宝
        }).then((res) => {
          if (res.errno === 0) {
            this.get_coupon_list()
            this.accept_id = 0
            if (res.code == 1035) {
              this.$router.push({ path: '/succeed?order_id=' + res.data.order_id })
            } else if (res.data.pay_info.pay_info.code_url) {
              this.pay_popup = true
              this.pay_money = res.data.pay_money
              setTimeout(() => {
                this.make(res.data.pay_info.pay_info.code_url)
                let order_id = res.data.order_id
                this.pay_timer = setInterval(() => {
                  this.get_order_detail(order_id)
                }, 1000)
              }, 100)
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error',
            })
          }
        })
      },
      buy_course2 (pay_way) {
        this.API.post('user/course_in-buy_course', {
          course_id: this.course_id,
          accept_id: this.accept_id, // 用户优惠券ID
          is_h5: 2,
          pay_way: pay_way, // 	支付方式 1.余额 2.微信 3支付宝
        }).then((res) => {
          if (res.errno === 0) {
            this.get_coupon_list()
            this.accept_id = 0
            this.$router.push({ path: '/succeed?order_id=' + res.data.order_id })
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error',
            })
          }
        })
      },
      get_detail () {
        this.API.post('Home/course_out-get_course_info', {
          course_id: this.course_id
        }).then((res) => {
          this.detail_info = res.data.course_info
        })
      },
      use_coupon () {
        this.dialogVisible = false
      },
      get_coupon_list () {
        this.API.post('user/coupon_in-get_coupon_list', {
          course_id: this.course_id
        }).then((res) => {
          console.log(res)
          this.coupon_list = res.data.coupon_list
        })
      }
    },
    watch: {
      pay_popup: function () {
        if (!this.pay_popup) {
          this.clear_pay_timer()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .w-view-shell {
        padding: 20px;
    }

    .purchase-shell {
        width: 1200px;
        height: 720px;
        padding: 35px 26px;
        background: #FFFFFF;

        .purchase-header {
            display: flex;
            align-items: center;
            width: 1140px;
            height: 50px;
            background: #F8F8F8;
            border: 1px solid #E5E5E5;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;

            .purchase-header-box {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .goods-shell {
            display: flex;
            width: 1140px;
            height: 170px;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;

            .goods-info {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 16px;

                .goods-img {
                    width: 183px;
                    height: 110px;
                    margin-right: 14px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .goods-info-shell {
                    width: 369px;
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #000000;

                    .goods-name {
                        margin-bottom: 20px;
                    }

                    .goods-type {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #999999;
                        margin-bottom: 10px;
                    }
                }
            }
        }

        .coupon-shell {
            width: 1140px;
            height: 134px;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            margin-top: 25px;

            .coupon-title {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                margin: 21px 0 20px 29px;
            }

            .select-coupon-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 159px;
                height: 50px;
                background: #18949C;
                border-radius: 5px;
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                margin-left: 29px;
            }
        }

        .order-shell {
            width: 1140px;
            height: 134px;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            margin-top: 20px;

            .order-info {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;
                padding-left: 18px;
                margin-top: 16px;
            }

            .order-price {
                font-size: 20px;
                color: #EA3C46;
            }
        }

        .handle-list {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
            margin-top: 32px;
            padding: 0 20px;
        }

        .pay-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 159px;
            height: 54px;
            background: #18949C;
            border-radius: 5px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            margin-left: 30px;
            cursor: pointer;
        }
    }

    .coupon-shell-show {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 200px;
        margin-left: 20px;
        background-color: #2aa9b5;
        color: #fff;
        border-radius: 10px;
    }

    .handle-btn {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2AA9B5;
    }

    .goods-price {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #EB2020;
    }

    .coupon-popup-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 9;
        background-color: rgba(0, 0, 0, .5);

        .pay-content {
            width: 1050px;
            height: 574px;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 80px;

            .pay-content-header {
                text-align: center;

                .title {
                    font-size: 26px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                }

                .pay-price {
                    font-size: 40px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #D8251C;
                    margin-top: 20px;
                }
            }

            .qrcode-list {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 50px;

                .qrcode-box {
                    width: 210px;
                    height: 210px;
                }

                .text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 30px;

                    img {
                        width: 25px;
                        height: 22px;
                        margin-right: 10px;
                    }
                }
            }
        }

        .coupon-popup-content {
            width: 1050px;
            min-width: 1050px;
            height: 574px;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 80px 40px;
            position: relative;

            .coupon-list {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                width: 100%;
                height: 100%;
                overflow-x: hidden;
                overflow-y: scroll;

                .coupon-box {
                    width: 210px;
                    min-width: 210px;
                    height: 237px;
                    min-height: 237px;
                    margin-right: 30px;
                    background-image: url("../../../assets/222222.png");
                    background-size: 100% 100%;
                    margin-bottom: 60px;
                    cursor: pointer;

                    .info-header {
                        height: 60%;

                        .info-tips {
                            text-align: center;
                            font-size: 36px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #FFFDFD;
                            padding-top: 40px;
                        }

                        .info-price {
                            text-align: center;
                            font-size: 18px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #FDFBFB;
                        }
                    }

                    .info-bottom {
                        height: 40%;
                        text-align: center;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #333333;
                        padding-top: 20px;

                        .info-desc {
                            margin-bottom: 10px;
                        }
                    }
                }
            }

            .coupon-handle {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                width: 100%;
                bottom: 10px;
                left: 10px;
                z-index: 9;
                cursor: pointer;

                .handle-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 116px;
                    height: 46px;
                    border: 1px solid #2AA9B5;
                    border-radius: 5px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #2AA9B5;
                    margin-right: 40px;
                }

                .handle-btn2 {
                    background: #2AA9B5;
                    color: #fff;
                }
            }
        }

        .select-box {
            width: 24px;
            height: 24px;
            margin: 10px auto 0;
            border: 1px solid #cccccc;
            border-radius: 50%;
        }
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        font-weight: 400;
        color: #000;
        cursor: text;
    }

    .el-breadcrumb {
        height: 47px;
        line-height: 47px;
    }

</style>
